import { render } from "./eyeNavbar.vue?vue&type=template&id=799808df"
import script from "./eyeNavbar.vue?vue&type=script&lang=js"
export * from "./eyeNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__